/**
 * URL パス → 機能権限コード（featureCode）の対応表と解決ヘルパー。
 *
 * router.beforeEach の権限ガードと、VerticalNavMenu が API から最新権限を取得した直後の
 * 現在ルート再判定の両方で参照するため、純粋関数として独立ファイルに切り出している。
 *
 * featureCode の値は `src/layouts/components/vertical-nav-menu/navMenuItems.js` の
 * `featureCode` と統一すること。配列順は「より具体的な prefix を先」に並べる
 * （getFeatureCodeForPath は先頭一致で最初にマッチしたものを返すため）。
 */
export const PATH_FEATURE_CODE_MAP = [
  { prefix: "/enterprise/management/crews/crew-settings", code: "CREW_CREW_SETTINGS" },
  { prefix: "/enterprise/management/crews/crew-status-list", code: "CREW_LABOR" },
  { prefix: "/enterprise/management/crew-operator", code: "OPERATION_CREW" },
  { prefix: "/enterprise/addon/crew-assignment-management", code: "CREW_SCHEDULER" },
  { prefix: "/enterprise/addon/crew-data-management", code: "CREW_DATA_IO" },
  { prefix: "/enterprise/addon/operation", code: "OPERATION_REPORT" },
];

/**
 * パスに対応する featureCode を返す。該当なしの場合は null。
 * 呼び元で `to.meta.featureCode` が明示されている場合はそちらを優先する。
 */
export function getFeatureCodeForPath(path) {
  if (!path) return null;
  for (const { prefix, code } of PATH_FEATURE_CODE_MAP) {
    if (path === prefix || path.startsWith(prefix + "/")) {
      return code;
    }
  }
  return null;
}

export const DEFAULT_PRODUCT_NAME = "Aisea PRO";

/**
 * featureCode → プロダクト名の対応表。
 * 機能制限ダイアログで「{プロダクト名}を契約すると利用できます」の表示に使用する。
 * navMenuItems.js の featureCode と整合させること。
 */
export const FEATURE_CODE_PRODUCT_NAME_MAP = {
  CREW: "Aisea Crew",
  CREW_CREW_SETTINGS: "Aisea Crew",
  CREW_SCHEDULER: "Aisea Crew",
  CREW_LABOR: "Aisea Crew",
  CREW_DATA_IO: "Aisea Crew",
  OPERATION: "Aisea Operation",
  OPERATION_REPORT: "Aisea Operation",
  OPERATION_SAFETY_DOCUMENT: "Aisea Operation",
  OPERATION_CREW: "Aisea Operation",
};

/**
 * featureCode に対応するプロダクト名を返す。該当なしの場合は既定の "Aisea PRO"。
 */
export function getProductNameForFeatureCode(featureCode) {
  if (!featureCode) return DEFAULT_PRODUCT_NAME;
  return FEATURE_CODE_PRODUCT_NAME_MAP[featureCode] || DEFAULT_PRODUCT_NAME;
}
